var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Divider, List, ListItem, Popover, PopoverContent, PopoverTrigger, forwardRef, useMergeRefs, } from "@chakra-ui/react";
import { useCombobox, } from "downshift";
import { TextField } from "../text-field";
export const AutocompleteSuggestionList = forwardRef((_a, ref) => {
    var { value, isOpen, suggestions, highlightedIndex, getItemProps, sx } = _a, rest = __rest(_a, ["value", "isOpen", "suggestions", "highlightedIndex", "getItemProps", "sx"]);
    return (React.createElement(List, Object.assign({ sx: Object.assign({ boxShadow: "rgb(0 0 0 / 32%) 0px 4px 16px", maxHeight: "420px", overflowY: "scroll" }, sx), ref: ref }, rest)));
});
export const AutocompleteSuggestionListItem = forwardRef((_a, ref) => {
    var { children, sx, index, highlightedIndex, isLast } = _a, rest = __rest(_a, ["children", "sx", "index", "highlightedIndex", "isLast"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, Object.assign({ ref: ref, sx: Object.assign({ display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1, padding: "small", backgroundColor: highlightedIndex === index ? "rgba(0, 0, 0, 0.06)" : "white" }, sx) }, rest), children),
        isLast ? null : React.createElement(Divider, null)));
});
export const matchWidthModifier = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn: ({ state }) => {
        state.styles.popper.minWidth = "auto";
        state.styles.popper.maxWidth = `${state.rects.reference.width}px`;
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }) => () => {
        const reference = state.elements.reference;
        state.elements.popper.style.width = `${reference.offsetWidth}px`;
    },
};
function stateReducer(state, actionAndChanges) {
    const { type, changes } = actionAndChanges;
    switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
            return Object.assign(Object.assign({}, changes), { isOpen: changes.inputValue ? changes.inputValue.length !== 0 : false });
        default:
            return changes;
    }
}
export const AutocompleteInput = forwardRef((_a, ref) => {
    var { onChange, value = "", suggestions = [], onSelectSuggestion, suggestionToString, SuggestionListItem = AutocompleteSuggestionListItem, SuggestionList = AutocompleteSuggestionList, listContainerSx, popoverContentSx, suggestionsOffset = 0, matchWidth = true, keepSuggestionsOpen = false } = _a, rest = __rest(_a, ["onChange", "value", "suggestions", "onSelectSuggestion", "suggestionToString", "SuggestionListItem", "SuggestionList", "listContainerSx", "popoverContentSx", "suggestionsOffset", "matchWidth", "keepSuggestionsOpen"]);
    const { isOpen: boxIsOpen, getMenuProps, highlightedIndex, getItemProps, getInputProps, getComboboxProps, } = useCombobox({
        items: suggestions,
        itemToString: suggestionToString
            ? suggestionToString
            : (suggestion) => suggestion,
        stateReducer: stateReducer,
        initialIsOpen: false,
        defaultIsOpen: false,
        onInputValueChange: ({ inputValue }) => {
            if (onChange) {
                onChange(inputValue || "");
            }
        },
        onSelectedItemChange: onSelectSuggestion,
    });
    const _b = getInputProps(), { ref: downshiftInputRef } = _b, inputProps = __rest(_b, ["ref"]);
    const refs = useMergeRefs(ref, downshiftInputRef);
    const isOpen = keepSuggestionsOpen || boxIsOpen;
    return (React.createElement(Popover, { isOpen: isOpen, autoFocus: false, modifiers: [Object.assign(Object.assign({}, matchWidthModifier), { enabled: matchWidth })], gutter: suggestionsOffset },
        React.createElement(PopoverTrigger, null,
            React.createElement(Box, Object.assign({}, getComboboxProps(), { width: "100%" }),
                React.createElement(TextField, Object.assign({}, inputProps, { value: value, ref: refs }, rest, { borderBottomRadius: isOpen && suggestions.length ? 0 : undefined })))),
        React.createElement(PopoverContent, Object.assign({}, getMenuProps(), { sx: Object.assign({ borderTopLeftRadius: 0, borderTopRightRadius: 0, width: "100%", border: "none" }, popoverContentSx) }), (keepSuggestionsOpen || suggestions.length > 0) && (React.createElement(SuggestionList, { value: value, suggestions: suggestions, isOpen: isOpen, highlightedIndex: highlightedIndex, getItemProps: getItemProps, sx: Object.assign({ boxShadow: "rgb(0 0 0 / 32%) 0px 4px 16px", maxHeight: "420px", overflowY: "auto", overflowX: "hidden" }, listContainerSx) }, isOpen &&
            suggestions.map((item, index) => (React.createElement(SuggestionListItem, Object.assign({ key: index }, getItemProps({ item, index }), { index: index, isLast: suggestions.length - 1 === index, highlightedIndex: highlightedIndex }), suggestionToString ? suggestionToString(item) : item))))))));
});
